import { getWidgetDataEvent } from '../../../utils/peregrine';

const birthdateField = {
  type: 'FormInput',
  props: {
    name: 'birthdate',
    component: {
      type: 'Inputs.DateInput',
      props: {
        fieldName: 'getUserInput.birthdate',
        _label: 'Geboortedatum',
        _containerProps: {
          flex: 1,
          display: 'flex',
        },
        placeholder: 'dd-mm-jjjj',
        iconPosition: 'right',
        inputMode: 'numeric',
      },
    },
  },
};

const startWidget = {
  name: 'startWidget',
  components: [
    {
      type: 'StartWidget',
      props: {
        titleProps: {
          as: 'h2',
        },
        title: 'Start met vergelijken',
        direction: 'vertical',
        fieldNames: ['*.postcode', '*.birthdate', '*.gender'],
        css: {
          '& > h2': {
            fontSize: 24,
            mt: 0,
            ml: '20px',
          },
          paddingBottom: 5,
          paddingX: 0,
        },
        position: 'relative',
        registerInPeregrine: true,
        getWidgetDataEvent,
        footerContent: {
          type: 'StartWidgetFooter',
          props: {
            text: 'Unieke Tandongevallen-verzekering',
            icon: 'tooth',
            marginTop: '16px',
          },
        },
      },
      _children: [
        {
          type: 'Div',
          props: { width: '90%', margin: 'auto' },
          _children: [
            {
              type: 'Div',
              props: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                css: {
                  gap: 5,
                },
              },
              _children: [
                {
                  type: 'Div',
                  props: {
                    display: 'flex',
                    css: {
                      gap: 15,
                    },
                  },
                  _children: [
                    {
                      type: 'PostcodeFieldWrapper',
                      props: {
                        isStartWidget: true,
                        _label: 'Postcode',
                        _tooltip:
                          'Je postcode kan invloed hebben op het aantal beschikbare zorgverleners',
                        _containerProps: {
                          flex: 1,
                        },
                        placeholder: '1234AB',
                      },
                    },
                    birthdateField,
                  ],
                },
                {
                  type: 'FormInput',
                  props: {
                    name: 'gender',
                    component: {
                      type: 'Inputs.TileRadioGroup',
                      props: {
                        _label: 'Geslacht',
                        _tooltip:
                          'Wij stellen je deze vraag zodat we de best passende dekkingen voor je kunnen tonen.',
                        name: 'gender',
                        _fieldName: 'getUserInput.gender',
                        direction: 'horizontal',
                        displayTilesInRow: true,
                        style: {
                          height: '54px',
                          borderRadius: '8px',
                        },
                        radios: [
                          {
                            text: 'Man',
                            value: 'male',
                          },
                          {
                            text: 'Vrouw',
                            value: 'female',
                          },
                        ],
                      },
                    },
                  },
                },
              ],
            },
            {
              type: 'Div',
              props: {
                display: 'flex',
                justifyContent: 'flex-end',
              },
              _children: [
                {
                  type: 'FormSubmitOsHealth',
                  props: {
                    width: '100%',
                    children: 'Vergelijk zorgverzekeringen',
                    variant: 'primary',
                    mt: 6,
                  },
                },
              ],
            },
            {
              type: 'AFMBanner',
            },
          ],
        },
        { type: 'WidgetCountdown' },
      ],
    },
  ],
};

export default startWidget;
